import "../../assets/font/icon.css";
import "../../assets/font/iconStyle.css";

const CustomIcon = (props) => {
  const {iconName, iconClass, onSelect, actived} = props;

  return <li style={{margin: 8}} className={["icon-container", `${actived ? "active" : ""}`].join(" ")}
    onClick={() => onSelect(iconName, iconClass)}
  >
    <span className={["app-icon", iconClass].join(" ")}></span>
  </li>;
};

export default CustomIcon;
